if ($('.type-detail').length) {

$(function () {

    /* ==================================================
       KONSTANTY
    ================================================== */

    const FRIENDS_LABEL = '#kamarádi';
    const API_URL = 'https://ventila-8593.rostiapp.cz/ventila/ventila-variants.php';

    // levely, které se mají renderovat jako DIV (ne select)


    const productCode = String(getShoptetDataLayer('product').codes[0].code);

    /* ==================================================
       1) SKRYTÍ TECHNICKÝCH ŘÁDKŮ
    ================================================== */

    let hasFriends = false;

    $('table.detail-parameters tbody tr').each(function () {
        const label = $(this).find('th span.row-header-label').text().trim();

        if (label.includes('#kamarádi') || label.includes('#slozeni')) {
            $(this).hide();
        }

        if (label.includes(FRIENDS_LABEL)) {
            hasFriends = true;
        }
    });

        if (!hasFriends) return;
//console.log('hasFriends:', hasFriends);
    /* ==================================================
       2) API REQUEST
    ================================================== */

    $.getJSON(API_URL, { code: productCode })
        .done(initVariants)
        .fail(err => console.error('Ventila API error:', err));

    /* ==================================================
       3) INIT VARIANT
    ================================================== */

    function initVariants(response) {
     /*   if (response.product_visibility !== 'visible') {
            return;
        }*/

        if (!response || !response.levels || !response.variants) return;

        const levels = response.levels;
        const variants = response.variantMode === 'tree'
        ? flattenVariantsTree(response.variants)
        : response.variants;
        const variantMode = response.variantMode || 'flat';

        const $container = $('<div class="friendsSection"></div>');
        const selected = {};

        /* ==============================================
           4) DEFAULTNÍ VÝBĚR (AKTUÁLNÍ PRODUKT)
        ============================================== */

        const current = variants.find(v => String(v.code) === productCode);
if (current) {
    levels.forEach(lvl => {
        selected[lvl.key] = current[lvl.key] ?? null;
    });
}

        /* ==============================================
           5) RENDER LEVELŮ
        ============================================== */
levels.forEach(lvl => {

    const isDiv = FRIENDS_DIV_LEVELS.includes(lvl.key);

    if (isDiv) {
        $container.append(`
            <div class="friendsBlock friendsBlock--div" data-level="${lvl.key}">
                <span class="friendsBlock__label">${lvl.label}</span>
                <div class="friendsOptions"></div>
            </div>
        `);
    } else {
        $container.append(`
            <div class="friendsBlock friendsBlock--select">
                <span class="friendsBlock__label">${lvl.label}</span>
                <select class="friendsBlock__select" data-level="${lvl.key}">
                    <option value="">Vyberte</option>
                </select>
            </div>
        `);
    }
});


        $('.p-data-wrapper #product-detail-form').prepend($container);

        /* ==============================================
           6) COMPOUND PARSER
        ============================================== */

        function parseCompoundValue(val) {
            if (!val) return null;

            const parts = val.split('/').map(p => p.trim());

            return {
                diameter: parseInt(parts[0]?.replace(/[^\d]/g, ''), 10) || 0,
                flow:     parseInt(parts[1]?.replace(/[^\d]/g, ''), 10) || 0,
                voltage:  parseInt(parts[2]?.replace(/[^\d]/g, ''), 10) || 0,
                raw: val
            };
        }

        /* ==============================================
           7) UPDATE SELECTŮ / DIVŮ
        ============================================== */

        function updateSelects() {

            levels.forEach((lvl, index) => {

                const isDiv = FRIENDS_DIV_LEVELS.includes(lvl.key);

                const filtered = variants.filter(v => {
                    if (!v.url) return false;

                    for (let i = 0; i < index; i++) {
                        const k = levels[i].key;
                        if (selected[k] && v[k] !== selected[k]) return false;
                    }
                    return true;
                });

                // ✅ 1) vytvořit values
                //let values = [...new Set(filtered.map(v => v[lvl.key]).filter(Boolean))];
let values = [];

filtered.forEach(v => {
    if (v.variant_visible !== 1) return;
    if (!v[lvl.key]) return;
    if (!v.url) return;

    values.push(v[lvl.key]);
});

values = [...new Set(values)];

                // ✅ 2) teprve teď validovat selected
                if (selected[lvl.key] && !values.includes(selected[lvl.key])) {
                    selected[lvl.key] = null;
                }

                /* ---------- ŘAZENÍ ---------- */
                if (lvl.type === 'compound') {
                    values = values
                        .map(parseCompoundValue)
                        .filter(Boolean)
                        .sort((a, b) =>
                            a.diameter - b.diameter ||
                            a.flow - b.flow ||
                            a.voltage - b.voltage
                        )
                        .map(v => v.raw);
                } else {
                    values.sort((a, b) =>
                        a.localeCompare(b, 'cs', { numeric: true, sensitivity: 'base' })
                    );
                }

                /* ---------- DIV ---------- */

                if (isDiv) {
                    const $wrap = $(`.friendsBlock--div[data-level="${lvl.key}"] .friendsOptions`);
                    $wrap.empty();

                    loadColorJSON(colors => {

                        values.forEach(val => {
                            const variant = filtered.find(v => v[lvl.key] === val && v.url);
                            const isActive = selected[lvl.key] === val;
                            const colorData = getColorData(colors, val);

                            const $item = $(`
                                <a href="${variant?.url || '#'}"
                                   class="friendsOption ${isActive ? 'is-active' : ''}"
                                   data-value="${val}">
                                    <span class="friendsOption__label">${val}</span>
                                </a>
                            `);

                            if (colorData) applyColorStyle($item, colorData);
                            $wrap.append($item);
                        });
                    });

                    if (!selected[lvl.key] && values.length === 1) {
                        selected[lvl.key] = values[0];
                    }

                    return;
                }

                /* ---------- SELECT ---------- */

                const $select = $(`select[data-level="${lvl.key}"]`);
                $select.find('option:not(:first)').remove();

                values.forEach(val => {
                    $select.append(`<option value="${val}">${val}</option>`);
                });

                $select.val(selected[lvl.key] || '');
                $select.prop('disabled', values.length <= 1);
            });
        }

        updateSelects();

        /* ==============================================
           8) EVENTS
        ============================================== */

        $container.on('click', '.friendsOption', function (e) {
            e.preventDefault();

            const $opt = $(this);
            const value = $opt.data('value');
            const levelKey = $opt.closest('.friendsBlock').data('level');

            selected[levelKey] = value;

            $opt.addClass('is-active').siblings().removeClass('is-active');

            updateSelects();

            const matches = variants.filter(v =>
                levels.every(lvl =>
                    selected[lvl.key] && v[lvl.key] === selected[lvl.key]
                )
            );

            if (matches.length === 1 && matches[0].url) {
                window.location.href = matches[0].url;
            }
        });

        $container.on('change', 'select', function () {

            const key = $(this).data('level');
            selected[key] = $(this).val() || null;

            updateSelects();

            const matches = variants.filter(v =>
                levels.every(lvl =>
                    selected[lvl.key] && v[lvl.key] === selected[lvl.key]
                )
            );

            if (matches.length === 1 && matches[0].url) {
                window.location.href = matches[0].url;
            }
        });

        if (typeof initTooltips === 'function') {
            initTooltips();
        }
    }
});

/* ==================================================
   BARVY / HELPERY
================================================== */

function loadColorJSON(callback) {
    const cached = sessionStorage.getItem('colors');
    if (cached) return callback(JSON.parse(cached));

    $.getJSON('/user/documents/variantImages/customColorsVariant.json?v=' + Date.now(), data => {
        sessionStorage.setItem('colors', JSON.stringify(data));
        callback(data);
    });
}

function getColorData(colors, name) {
    return colors?.find(c => c.color_name === name) || null;
}

function applyColorStyle($el, color) {
    if (color.image_url) {
        $el.css({
            backgroundImage: `url(${color.image_url.replace('uploads/', '/user/documents/variantImages/')})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
        });
    } else if (color.hex_code) {
        $el.css('background-color', color.hex_code);
        $el.css('color', getContrastTextColor(color.hex_code));
    }
}

function hexToRgb(hex) {
    hex = hex.replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(x => x + x).join('');
    const num = parseInt(hex, 16);
    return { r: num >> 16 & 255, g: num >> 8 & 255, b: num & 255 };
}

function getContrastTextColor(hex) {
    const { r, g, b } = hexToRgb(hex);
    const l = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return l > 0.6 ? '#000' : '#fff';
}

}


function flattenVariantsTree(tree) {
    const result = [];

    function walk(node) {
        if (Array.isArray(node)) {
            node.forEach(v => result.push(v));
            return;
        }
        if (typeof node === 'object' && node !== null) {
            Object.values(node).forEach(walk);
        }
    }

    walk(tree);
    return result;
}
